import React from "react";
import { motion } from "framer-motion";
import { GlobeAltIcon, LightBulbIcon } from "@heroicons/react/24/outline";

import {
  etInvestor1,
  
} from "@/assets/img/imageAssets.js"

const EtInvestorsVision = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey

  return (
    <section
      id="vision"
      className="relative py-20 bg-gray-900 text-white overflow-hidden"
    >
      {/* Gradient background animation */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-800 to-black animate-[pulse_12s_ease-in-out_infinite]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-orange-600 mb-6">
            Our Vision for the Future
          </h2>
          {/* <p className="text-gray-300 mb-6 text-lg">
            Eternity is building the world’s first ecosystem for tech-services
            leadership growth — combining AI, behavioral science, and structured
            execution systems to transform how organizations lead, perform, and
            scale.
          </p> */}
          <p className="text-gray-300 mb-6 text-lg">
            Eternity is building the world’s first ecosystem for tech-led
            enterprise growth. Combining AI, behavioral science, and structured
            execution systems to transform how organizations lead, perform, and
            scale.
          </p>

          <p className="text-gray-300 mb-6">
            Our long-term vision is to establish Trinity as the industry’s
            most trusted AI-powered growth companion. Enabling founders,
            CEOs, and investors to drive measurable business outcomes through
            human-centered intelligence.
          </p>

          <ul className="space-y-4 text-gray-300">
            <li className="flex items-start gap-3">
              <LightBulbIcon className="h-6 w-6 text-orange-500 shrink-0" />
              <span>
                Redefining tech-led business growth through purpose-native
                organizations.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <GlobeAltIcon className="h-6 w-6 text-orange-500 shrink-0" />
              <span>
                Creating a global leadership movement that blends AI innovation
                with human clarity and conviction.
              </span>
            </li>
          </ul>
        </motion.div>

        {/* Right Visual */}
        <motion.div
          className="rounded-xl overflow-hidden shadow-lg"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={etInvestor1}
            alt="Eternity Vision"
            className="w-full h-auto object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default EtInvestorsVision;